import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import i18n from 'i18next';

import { createIconComponent } from 'uikit/icons';

import Close from '@mui/icons-material/Close';

import Button from '../../buttons/components/button';
import Markdown from '../../content/components/markdown';
import Typo from '../../content/components/typo';

import styles from '../styles/formCallout.module.scss';

const VARIANTS = {
  default: styles.isVariantDefault,
  ai: styles.isVariantAi,
  warning: styles.isVariantWarning,
};

const FormCallout = ({ fieldId, schema }) => {
  const getText = () => (
    <>
      {schema.heading && (
        <Typo className={styles.textHeading} variant="s03" weight="medium">
          {schema.heading}
        </Typo>
      )}
      {schema.hasMarkdownText ? (
        <Markdown className={styles.textBodyMarkdown} content={schema.text} />
      ) : (
        <Typo className={styles.textBody} element="div" variant="s02">
          {schema.text}
        </Typo>
      )}
    </>
  );

  return (
    <div
      className={classnames(styles.element, {
        [VARIANTS[schema.variant]]: schema.variant,
      })}
      id={fieldId}
    >
      <div className={styles.iconContainer}>
        {createIconComponent({ icon: schema.icon, size: '24' })}
      </div>
      <div className={styles.content}>
        <div className={styles.text}>{getText()}</div>
        {schema.actions && <div className={styles.actions}>{schema.actions}</div>}
        {schema.hasCloseButton && (
          <div className={styles.actions}>
            <Button
              ariaLabel={i18n.t('close')}
              icon={<Close />}
              onClick={schema.onCloseButtonClick || (() => {})}
              size="xsmall"
              variant="ghost"
              className={styles.closeButton}
            />
          </div>
        )}
      </div>
    </div>
  );
};

FormCallout.propTypes = {
  fieldId: PropTypes.string.isRequired,
  schema: PropTypes.shape({
    actions: PropTypes.node,
    hasCloseButton: PropTypes.bool,
    hasMarkdownText: PropTypes.bool,
    heading: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    icon: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    onCloseButtonClick: PropTypes.func,
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    variant: PropTypes.oneOf(['default', 'ai', 'warning']),
  }).isRequired,
};

export default FormCallout;
